var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"mb-10 text-center"},[_vm._v(" "+_vm._s(_vm.getTimeOfDayMessage())+" ")]),_c('my-projects')],1)}
var staticRenderFns = []

export { render, staticRenderFns }